const initialState = {
    loading: true,
    traitGroupItems: [],
    badges:[],
    idTraitGroupItems: 0,
    dataGrowthChart: {
        date: [],
        traitGroupScoreHistorys: [
            {
                countLC: 0,
                traitGroupName: '',
                createdDate: '',
                percent: 0,
                title: '',
                traitGroupId: 0,
            }
        ],
        percentByTraitGroups: [
            {
                percent: [],
                traitGroupName: '',
            }
        ],
    }
};

const profileReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'SET_LOADING':
            return { ...state, loading: action.loading };
        case 'SET_BADGES':
            return { ...state, badges: action.badges };
        case 'SET_TRAITGROUP_ITEM':
            return { ...state, traitGroupItems: action.traitGroupItems };
        case 'SET_ID_TRAITGROUP_ITEM':
            return { ...state, idTraitGroupItems: action.idTraitGroupItems }
        case 'SET_DATA_GROWTH_CHART':
            return { ...state, dataGrowthChart: action.dataGrowthChart }
        default:
            return state;
    }
}

export default profileReducer;